// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__tRCLc","notes":"Notes_notes__3x12k"};